import { html, LitElement } from 'lit';
export class BaseShadowless extends LitElement {
    constructor() {
        super(...arguments);
        // Declare a private property to hold the slot name
        this.slotNames = '';
    }
    /**
     * The createRenderRoot function is a function that is called by the lit-html library to tell the
     * component where to render the html.
     * @returns The element itself.
     */
    createRenderRoot() {
        return this;
    }
    /**
     * Sets the slotNames property to the given slotName argument,
     * then searches the component's child nodes for an element with
     * a slot attribute that matches the slotNames value.
     * @param slotName The name of the slot to search for.
     * @returns The child element with the matching slot name, or null if none is found.
     */
    checkHaveSlots(slotName) {
        // Set the slotNames property to the given slotName argument
        this.slotNames = slotName;
        // Search the child nodes for a slot with a matching name
        const slotElement = this.searchSlots();
        return slotElement;
    }
    /**
     * Searches the component's child nodes for an element with a slot attribute
     * that matches the slotNames value (which is set by the checkHaveSlots method).
     * @returns The child element with the matching slot name, or null if none is found.
     */
    searchSlots() {
        let childElement = null;
        // Loop through the component's child nodes
        this.childNodes.forEach((child) => {
            var _a;
            const { attributes } = child;
            if (!attributes)
                return;
            // If the child node has a slot attribute that matches the slotNames value,
            // set the childElement variable to that node.
            if (((_a = attributes.slot) === null || _a === void 0 ? void 0 : _a.value) === this.slotNames) {
                // Correct name
                childElement = child;
            }
        });
        return childElement;
    }
    /**
     * Renders the child elements of the component by calling the checkHaveSlots method
     * with the given slot name, and passing the result to the html function from the Lit library.
     * @param slotName The name of the slot to render.
     * @returns The child element with the matching slot name, or null if none is found.
     */
    shadowlessRender(slotName) {
        return html `${this.checkHaveSlots(slotName)}`;
    }
}
//# sourceMappingURL=BaseShadowless.js.map